import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import {
  getScriberequests,
  deleteScriberequest,
  getNextScriberequests,
  getPreviousScriberequests,
} from "../../store/actions/scriberequests_action";
import { LIMIT } from "../../domain/constant";
import Pagination from "../../components/common/Pagination";
import Filters from "../../components/common/Filters";
import AddBtn from "../../components/common/AddBtn";
import {
  SEARCH_TERMS,
  view_all_table,
} from "../../shared/enums/scriberequests_enum";
import DataTable from "../../components/common/DataTable";
const AllScriberequests = ({
  getScriberequests,
  deleteScriberequest,
  getNextScriberequests,
  getPreviousScriberequests,
  scriberequest: { loading, scriberequests },
}) => {
  const [page, setPage] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await deleteScriberequest(deleteEntry);
      }
      getScriberequests({});
    }
    allQuery();
  }, [deleteEntry]);

  const nextButtonClicked = () => {
    if (scriberequests && scriberequests.length === LIMIT) {
      const lastScriberequest = scriberequests[scriberequests.length - 1];
      getNextScriberequests({ last: lastScriberequest });
      setPage(page + 1);
    }
  };
  const prevBtnClicked = () => {
    if (page > 1) {
      const lastScriberequest = scriberequests[0];
      getPreviousScriberequests({
        first: lastScriberequest,
      });
      setPage(page - 1);
    }
  };
  const filterClicked = () => {
    if (term && term.length > 0) {
      setPage(1);
      setQ(term);
      getScriberequests({ term: term, termField: termField });
    }
  };
  const deleteScriberequestClicked = (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPage(1);
    setQ(null);
    setTerm("");
    getScriberequests({});
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Scriberequests"
          mainLinkTitle="Dashboard"
          mainLinkUrl="/dashboard"
          activeLink="Scriberequest"
        />

        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="card"
                style={{ boxShadow: "rgb(227 233 243) 0px 4px 22px" }}
              >
                <div className="card-body">
                  <AddBtn item="scriberequests" title="Scriberequest" />
                  <hr />

                  <Filters
                    q={q}
                    resetFilter={resetFilter}
                    setTerm={setTerm}
                    term={term}
                    filterClicked={filterClicked}
                    termField={termField}
                    setTermField={setTermField}
                    all_terms={SEARCH_TERMS}
                  />
                  <hr />
                  <div>
                    <DataTable
                      keys={view_all_table}
                      data={scriberequests}
                      field={"scriberequests"}
                      page={page}
                      deleteBtnClicked={deleteScriberequestClicked}
                      loading={loading}
                    />
                    <Pagination
                      data={scriberequests}
                      page={page}
                      prevBtnClicked={prevBtnClicked}
                      nextButtonClicked={nextButtonClicked}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ scriberequest: state.scriberequest });

const mapDispatchToProps = {
  getScriberequests,
  deleteScriberequest,
  getNextScriberequests,
  getPreviousScriberequests,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllScriberequests);
